/* eslint-disable import/no-anonymous-default-export */
export default (locationReceivedYearlyCost = [], action) => {
  switch (action.type) {
    case "LOCATION_STOCK_RECEIVED_YEARLY":
      return action.payload;

    default:
      return locationReceivedYearlyCost;
  }
};
